import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Bot } from 'lucide-react';
import { useTransition  } from '../hooks/useTranslation';

const brandBlue = "#1E88E5";

export default function AIDisclaimerModal({ show, onClose }) {

  return (
    <Modal 
      show={show} 
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header style={{ borderBottom: 'none', paddingBottom: 0 }}>
        <div className="d-flex align-items-center gap-3 w-100">
          <div
            className="rounded-circle d-flex justify-content-center align-items-center"
            style={{
              width: 48,
              height: 48,
              background: brandBlue,
            }}
          >
            <Bot className="text-white" size={24} />
          </div>
          <Modal.Title className="h5 mb-0">
            Hinweis zur Nutzung von Künstlicher Intelligenz
          </Modal.Title>
        </div>
      </Modal.Header>

      <Modal.Body style={{ paddingTop: '1rem' }}>
        <p className="mb-0" style={{ lineHeight: '1.6', color: '#666' }}>
          In dieser Lern-App werden KI-Funktionen eingesetzt, um dich beim Lernen zu unterstützen
          (z. B. Erklärungen, Übungsfeedback oder Hilfestellungen).
          Die KI trifft keine automatischen Entscheidungen über Leistungen oder Noten
          und ersetzt keine pädagogischen Entscheidungen von Lehrpersonen.
          Deine Eingaben werden ausschließlich zur Bearbeitung deiner Anfrage verwendet.
          
        </p>
        <p className="mb-0" style={{ lineHeight: '1.6', color: '#666' }}>
            fintogo verwendet keine Daten zum Trainieren der Modelle.
        </p>
      </Modal.Body>

      <Modal.Footer style={{ borderTop: 'none', justifyContent: 'center' }}>
        <Button 
          onClick={onClose}
          style={{
            background: brandBlue,
            borderColor: brandBlue,
            paddingLeft: '2rem',
            paddingRight: '2rem'
          }}
        >
          Verstanden
        </Button>
      </Modal.Footer>
    </Modal>
  );
}